export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5305.0119c4ff.jpg";